export const ReceiveRouting = [
  {
    path: "/safety/receive/list",
    name: "safety-receive-list",
    meta: { title: "安全整改验收" },
    component: () =>
      import(/* webpackChunkName: "safety-receive" */ "@/views/safety/receive/list/index.vue"),
  },
  {
    hidden: true,
    path: "/safety/receive/create",
    name: "safety-receive-create",
    meta: { title: "新增安全整改验收", comName: "SafetyReceiveFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "safety-receive" */ "@/views/safety/receive/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/safety/receive/edit/:id",
    name: "safety-receive-edit",
    meta: { title: "编辑安全整改验收", comName: "SafetyReceiveFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "safety-receive" */ "@/views/safety/receive/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/safety/receive/flowPrint/:id",
    name: "safety-receive-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "safety-receive" */ "@/views/safety/receive/form-print/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/safety/receive/detail/:id",
    name: "safety-receive-detail",
    meta: { title: "安全整改验收详情" },
    component: () =>
      import(
        /* webpackChunkName: "safety-receive" */ "@/views/safety/receive/form-detail/index.vue"
      ),
  },
];
